import { Navigate } from 'react-router-dom';
import { isAuthenticated, hasValidRole } from '../../../utils/auth';

const ProtectedRoute = ({ children, requiredRole }) => {
    const isAuth = isAuthenticated();
    const hasRole = hasValidRole(requiredRole);

    if (!isAuth || !hasRole) {
        // Redirect to auth page if not authenticated or doesn't have required role
        return <Navigate to="/auth" replace />;
    }

    return children;
};

export default ProtectedRoute;
